import { Label } from '@provision/entity-types';
import { gql, QueryHookOptions, useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { Records } from 'src/graphql/types';

const GET_VISIBLE_LABELS_QUERY = gql`
  query GetVisibleLabels @entity(name: "Label") {
    getVisibleLabels {
      records {
        id
        labelId
        partnerId
        labelGroupId
        displayName
        isPublic
        createdAt
        updatedAt
      }
    }
  }
`;

interface GetVisibleLabelsQuery {
  getVisibleLabels: Records<Label>;
}

export const useVisibleLabels = (options?: QueryHookOptions<GetVisibleLabelsQuery>) => {
  const { data, ...rest } = useQuery<GetVisibleLabelsQuery>(GET_VISIBLE_LABELS_QUERY, {
    ...options,
  });

  const labels = useMemo(
    () => data?.getVisibleLabels?.records || [],
    [data?.getVisibleLabels?.records],
  );

  return {
    labels,
    ...rest,
  };
};

export function useVisibleLabelOptions(options?: QueryHookOptions<GetVisibleLabelsQuery>) {
  const { labels } = useVisibleLabels(options);

  return useMemo(() => {
    if (!labels) return [];
    return labels.map((item) => ({
      id: item.id,
      value: item.id,
      label: item.displayName,
    }));
  }, [labels]);
}
